export const navigationItemID = 'navigationItem';

export const isNavItem = 'true';



// WEBPACK FOOTER //
// ./src/common/consts/navigationItem.js